import { FunctionComponent, Suspense } from 'react';
import { Flex } from '@monorepo/react-components';
import { TradingSystem } from '@monorepo/types';
import { CTraderLoginContent } from './c-trader-login-content';
import { TraderLoginContent } from './trader-login-content';
import { TradingPlatforms } from './trading-platforms';

export interface TradersLoginProps {
  userId: string;
  tradingSystem: TradingSystem;
  accountId?: string;
  contest?: boolean;
}

const TradersLogin: FunctionComponent<TradersLoginProps> = (props) => {
  const isCTrader = props.tradingSystem === TradingSystem.CTrader;

  return (
    // Suspense i18n
    <Suspense>
      <Flex gap={32} vertical className="traders-login">
        {isCTrader ? (
          <CTraderLoginContent tradingSystem={props.tradingSystem} />
        ) : (
          <TraderLoginContent {...props} />
        )}
        <TradingPlatforms tradingSystem={props.tradingSystem} />
      </Flex>
    </Suspense>
  );
};

export default TradersLogin;
